<app-vss-organization-menu [id]="formGroup.value.id"></app-vss-organization-menu>
<div class="container pt-4" style="padding-bottom: 150px;">
    <div class="row">
        <div class="col-12">
            <h4 class="border-bottom pb-2 color-primary"> {{'VSS.ORGANIZATION.INFORMATIONS.title' | translate}}
                <small class="form-text text-muted pl-2" style="font-size: 12px; display: block;">
                    {{'VSS.ORGANIZATION.INFORMATIONS.titleHelpText' | translate}}
                </small>
            </h4>
        </div>
    </div>
    <div class="row">
        <div class="col-12 offset-sm-5 col-sm-7 text-end">
            <select class="form-select form-select-sm mb-2" #languageSelect
                (change)="onLanguageChange(languageSelect.value)" [(ngModel)]="currentOrgLanguage">
                <option value="de">{{'GENERAL.german' | translate}}</option>
                <option value="it">{{'GENERAL.italian' | translate}}</option>
                <option value="en">{{'GENERAL.ladin' | translate}}</option>
            </select>
            <p class="form-text text-muted m-0"
                [innerHTML]="'VSS.ORGANIZATION.INFORMATIONS.mandatoryHelpText' | translate">
            </p>
        </div>
    </div>
    <form #orgInfoForm="ngForm" id="orgInfoForm" [formGroup]="formGroup" class="mt-3">
        <div class="form-group row">
            <div class="col">
                <label class="m-0 col-form-label">
                    {{'VSS.ORGANIZATION.INFORMATIONS.'+(organizationType === 6 ? 'president' : 'sectionPresident') |
                    translate}}
                </label>
            </div>
            <div class="col-sm-9">
                <input type="text" class="form-control form-control-sm" name="adminName" formControlName="adminName">
            </div>
        </div>
        <div class="form-group row">
            <div class="col">
                <label class="m-0">{{'VSS.ORGANIZATION.INFORMATIONS.name' | translate}}
                    *</label>
                <p class="form-text text-muted m-0">{{languageToString[currentOrgLanguage]}}</p>
            </div>
            <div class="col-sm-9">
                <ng-container [ngSwitch]="currentOrgLanguage">
                    <ng-container *ngSwitchCase="'de'">
                        <input type="text" class="form-control form-control-sm" id="name_de" name="name_de"
                            formControlName="name_de">
                    </ng-container>
                    <ng-container *ngSwitchCase="'en'">
                        <input type="text" class="form-control form-control-sm" id="name_en" name="name_en"
                            formControlName="name_en">
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <input type="text" class="form-control form-control-sm" id="name_it" name="name_it"
                            formControlName="name_it">
                    </ng-container>
                </ng-container>
            </div>
        </div>
        <div class="form-group row">
            <div class="col">
                <label class="m-0">{{'VSS.ORGANIZATION.INFORMATIONS.address' | translate}}
                    *</label>
                <p class="form-text text-muted m-0">{{languageToString[currentOrgLanguage]}}</p>
            </div>
            <div class="col-sm-9">
                <ng-container [ngSwitch]="currentOrgLanguage">
                    <ng-container *ngSwitchCase="'de'">
                        <input type="text" class="form-control form-control-sm" id="address_de" name="address_de"
                            formControlName="address_de">
                    </ng-container>
                    <ng-container *ngSwitchCase="'en'">
                        <input type="text" class="form-control form-control-sm" id="address_en" name="address_en"
                            formControlName="address_en">
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <input type="text" class="form-control form-control-sm" id="address_it" name="address_it"
                            formControlName="address_it">
                    </ng-container>
                </ng-container>
            </div>
        </div>
        <div class="form-group row">
            <div class="col">
                <label class="m-0">{{'VSS.ORGANIZATION.INFORMATIONS.website' | translate}}
                    *</label>
                <p class="form-text text-muted m-0">{{languageToString[currentOrgLanguage]}}</p>
            </div>
            <div class="col-sm-9">
                <ng-container [ngSwitch]="currentOrgLanguage">
                    <ng-container *ngSwitchCase="'de'">
                        <input type="text" class="form-control form-control-sm" id="webPage_de" name="webPage_de"
                            formControlName="webPage_de">
                    </ng-container>
                    <ng-container *ngSwitchCase="'en'">
                        <input type="text" class="form-control form-control-sm" id="webPage_en" name="webPage_en"
                            formControlName="webPage_en">
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <input type="text" class="form-control form-control-sm" id="webPage" name="webPage"
                            formControlName="webPage">
                    </ng-container>
                </ng-container>
            </div>
        </div>
        <div class="form-group row">
            <div class="col">
                <label class="m-0 col-form-label">
                    {{'VSS.ORGANIZATION.INFORMATIONS.phone' | translate}}
                </label>
            </div>
            <div class="col-sm-9">
                <input type="email" class="form-control form-control-sm" name="phone" formControlName="phone">
                <span class="small form-text text-danger block"
                    [hidden]="!formGroup.get('phone').hasError('required')">{{'GENERAL.required' | translate}}</span>
            </div>
        </div>
        <div class="form-group row">
            <div class="col">
                <label class="m-0 col-form-label">
                    {{'VSS.ORGANIZATION.INFORMATIONS.email' | translate}}
                </label>
            </div>
            <div class="col-sm-9">
                <input type="email" class="form-control form-control-sm" name="email" formControlName="email">
                <span class="small form-text text-danger block"
                    [hidden]="!formGroup.get('email').hasError('required')">{{'GENERAL.required' | translate}}</span>
            </div>
        </div>
        <div class="form-group row">
            <div class="col">
                <label class="m-0">{{'VSS.ORGANIZATION.INFORMATIONS.generalDescription' | translate}}
                </label>
                <p class="form-text text-muted m-0">{{languageToString[currentOrgLanguage]}}</p>
            </div>
            <div class="col-sm-9">
                <ng-container [ngSwitch]="currentOrgLanguage">
                    <ng-container *ngSwitchCase="'de'">
                        <quill-editor id="description_de" name="description_de" formControlName="description_de"
                            [placeholder]="'VSS.ORGANIZATION.INFORMATIONS.richTextFielPlaceholder' | translate"
                            [styles]="{height: '250px'}">
                        </quill-editor>
                        <small class="text-muted">{{'GENERAL.richTextFielHelpText' | translate}} <fa-icon
                                [icon]="icons['faLink']"></fa-icon>
                            {{'GENERAL.richTextFielHelpText2' | translate}}</small>
                    </ng-container>
                    <ng-container *ngSwitchCase="'en'">
                        <quill-editor id="description_en" name="description_en" formControlName="description_en"
                            [placeholder]="'VSS.ORGANIZATION.INFORMATIONS.richTextFielPlaceholder' | translate"
                            [styles]="{height: '250px'}">
                        </quill-editor>
                        <small class="text-muted">{{'GENERAL.richTextFielHelpText' | translate}} <fa-icon
                                [icon]="icons['faLink']"></fa-icon>
                            {{'GENERAL.richTextFielHelpText2' | translate}}</small>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <quill-editor id="description_it" name="description_it" formControlName="description_it"
                            [placeholder]="'VSS.ORGANIZATION.INFORMATIONS.richTextFielPlaceholder' | translate"
                            [styles]="{height: '250px'}">
                        </quill-editor>
                        <small class="text-muted">{{'GENERAL.richTextFielHelpText' | translate}} <fa-icon
                                [icon]="icons['faLink']"></fa-icon>
                            {{'GENERAL.richTextFielHelpText2' | translate}}</small>
                    </ng-container>
                </ng-container>
            </div>
        </div>
        <section class="mt-2 mb-2">
            <h4 class="border-bottom pb-2 color-primary">{{'VSS.ORGANIZATION.INFORMATIONS.image' | translate}}
                <small class="form-text text-muted pl-2" style="font-size: 12px; display: block;">
                    {{'VSS.ORGANIZATION.INFORMATIONS.imageHelpText' | translate}}
                </small>
            </h4>
            <div class="row">
                <div class="col-12 col-sm-6 text-center">
                    <ng-container *ngIf="imagePath; else elseTemplate">
                        <img [src]="imagePath" (click)="openLightbox()" class="img-fluid img-thumbnail"
                            style="height: 200px">
                        <div class="text-center mt-1" *ngIf="imagePath">
                            <button type="button" class="btn btn-sm btn-outline-danger"
                                (click)="deleteImage()">{{'GENERAL.delete' | translate}}</button>
                        </div>
                    </ng-container>
                    <ng-template #elseTemplate>
                        <img class="img-fluid img-thumbnail" style="height: 200px"
                            [src]="'assets/images/standard-picture-vss.png'" />
                    </ng-template>
                </div>
                <div class="col-12 col-sm-6">
                    <p class="form-text text-muted">
                        {{'VSS.ORGANIZATION.INFORMATIONS.uploadHelpText' | translate}}
                    </p>
                    <div class="custom-file mt-2">
                        <label class="form-label">
                            {{'VSS.ORGANIZATION.INFORMATIONS.browse' | translate}}
                        </label>
                        <input class="form-control form-control-sm" type="file" id="customFile"
                            (change)="handleImageFileInput($event)">
                        <small class="help-text text-danger" *ngIf="fileSizeError">
                            {{'VSS.ORGANIZATION.INFORMATIONS.fileSizeError' | translate}}
                        </small>
                    </div>
                </div>
            </div>
        </section>
        <section class="mt-2 mb-2">
            <h4 class="border-bottom pb-2 color-primary">{{'VSS.ORGANIZATION.INFORMATIONS.organizationFiles' |
                translate}}
                <small class="form-text text-muted pl-2" style="font-size: 12px; display: block;">
                    {{'VSS.ORGANIZATION.INFORMATIONS.organizationFilesHelpText' | translate}}
                </small>
            </h4>
            <div class="row">
                <app-vss-files-upload class="col" [type]="'organization'" [organizationId]="formGroup.value.id">
                </app-vss-files-upload>
            </div>
        </section>
        <section class="mt-2 mb-2">
            <h4 class="border-bottom pb-2 color-primary">{{'VSS.ORGANIZATION.INFORMATIONS.sportCategories' | translate}}
                <small class="form-text text-muted pl-2" style="font-size: 12px; display: block;">
                    {{'VSS.ORGANIZATION.INFORMATIONS.sportCategoriesHelpText' | translate}}
                </small>
            </h4>
            <div class="row">
                <div class="col" *ngFor="let sportCategory of sportCategories; let i=index">
                    <div class="list-group">
                        <label class="list-group-item" *ngFor="let category of sportCategory">
                            <ng-container *ngIf="category.children; else elseTemplate">
                                <strong>
                                    {{category['name_'+currentOrgLanguage]}}
                                </strong>
                            </ng-container>
                            <ng-template #elseTemplate>
                                <input class="form-check-input category-{{category.id}}" type="checkbox"
                                    [value]="category.id"
                                    [checked]="sportCategoriesFormArray.value.includes(category.id)"
                                    (change)="onSportCategoryChange($event)">
                                {{category['name_'+currentOrgLanguage]}}
                            </ng-template>
                            <div class="list-group mt-1" *ngIf="category.children">
                                <label class="list-group-item" *ngFor="let child of category.children">
                                    <input class="form-check-input category-{{child.id}}" type="checkbox"
                                        [value]="child.id" [checked]="sportCategoriesFormArray.value.includes(child.id)"
                                        (change)="onSportCategoryChange($event)">
                                    {{child['name_'+currentOrgLanguage]}}
                                </label>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
        </section>
        <section class="mt-2 mb-2">
            <h4 class="border-bottom pb-2 color-primary">
                {{'VSS.ORGANIZATION.INFORMATIONS.coordinates' | translate}}
                <small class="form-text text-muted pl-2" style="font-size: 12px; display: block;">
                    {{'VSS.ORGANIZATION.INFORMATIONS.coordinatesHelpText' | translate}}
                </small>
            </h4>
            <div style="height: 400px;" leaflet [leafletOptions]="options" [leafletLayers]="layers"
                (leafletClick)="onMapClick($event)">
            </div>
            <div class="row align-items-center mt-2">
                <div class="col">
                    <div class="form-group">
                        <label> {{'VSS.ORGANIZATION.INFORMATIONS.latitude' | translate}}</label>
                        <input type="text" class="form-control form-control-sm" name="latitude"
                            [placeholder]="formGroup.value.latitude" #newMapLatitude />
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>{{'VSS.ORGANIZATION.INFORMATIONS.longitude' | translate}}</label>
                        <input type="text" class="form-control form-control-sm" name="longitude"
                            [placeholder]="formGroup.value.longitude" #newMapLongitude />
                    </div>
                </div>
                <div class="col-auto text-end">
                    <div class="form-group">
                        <button type="button" class="btn btn-outline-success btn-sm mt-4" (click)="setNewMapLocation()">
                            {{'VSS.ORGANIZATION.INFORMATIONS.loadNewPosition' | translate}} </button>
                    </div>
                </div>
                <div class="col-auto text-end">
                    <div class="form-group">
                        <button type="button" class="btn btn-outline-danger btn-sm mt-4"
                            (click)="onMapResetClick()">{{'VSS.ORGANIZATION.INFORMATIONS.reset' | translate}}</button>
                    </div>
                </div>
            </div>
        </section>
    </form>
</div>
<nav class="navbar fixed-bottom navbar-expand-sm navbar-white bg-white" style="border-top: 1px solid #3f51b5;">
    <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav me-auto" style="margin: 0 auto;">
            <li class="nav-item text-center">
                <button type="button" class="btn btn-outline-primary" (click)="submitForm()">{{'GENERAL.save' |
                    translate}}</button>
            </li>
        </ul>
    </div>
</nav>
<app-toast></app-toast>
